var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState } from 'react';
import { Dropdown } from '../Dropdown';
import { CustomCheckbox } from '../CustomCheckbox';
var moveTimer;
var moveTimerDelay = 100;
;
export var Filters = function (_a) {
    var label = _a.label, filters = _a.filters, options = _a.options, onClose = _a.onClose, onChange = _a.onChange, forceClose = _a.forceClose, setFilters = _a.setFilters, setForceClose = _a.setForceClose, _b = _a.align, align = _b === void 0 ? 'left' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, buttonClassName = _a.buttonClassName, _d = _a.disabledButtonClassName, disabledButtonClassName = _d === void 0 ? 'disabled' : _d;
    var _e = useState(''), searchValue = _e[0], setSearchValue = _e[1];
    var onSearch = function (e) {
        setSearchValue(e.target.value);
    };
    var addFilter = function (e, option) {
        var alreadyExists = filters.filter(function (o) { return o.key === option.key && o.value === option.value; }).length === 1;
        // remove from filters in case if it exists
        if (alreadyExists) {
            // console.log(option);
            removeFilter({}, option);
            return;
        }
        // inserting into filters
        if (!option.options && !alreadyExists) {
            var newFilters = __spreadArray(__spreadArray([], filters), [option]);
            setFilters(function (oldFilters) { return (__spreadArray(__spreadArray([], oldFilters), [option])); });
            onChange && onChange(newFilters);
        }
    };
    var removeFilter = function (e, option) {
        var remainingFilters = filters.filter(function (o) { return (option.value !== o.value && option.label !== o.label); });
        setFilters(remainingFilters);
        onChange && onChange(remainingFilters);
    };
    var clearSearch = function () {
        setSearchValue('');
        var searchField = document.getElementById('filters_search');
        if (searchField) {
            searchField.value = '';
        }
    };
    var mouseMoveHanlder = function (e, level) {
        e.stopPropagation();
        var prevSubOptions = document.querySelector(".level-" + level + " > .abs-layer > ul.sub-options.show");
        var subOptions = e.target.querySelector(".level-" + level + " > .abs-layer > ul.sub-options");
        if (!subOptions) {
            if (prevSubOptions) {
                if (prevSubOptions.contains(e.target)) {
                    // inside children
                    // treating previous one as sub options if the cursor is already on options
                    subOptions = prevSubOptions;
                }
            }
            else {
                return;
            }
        }
        // clears previous timer and udpates new timer on moving mouse
        clearTimeout(moveTimer);
        moveTimer = setTimeout(function () {
            if (prevSubOptions) {
                prevSubOptions.classList.remove('show');
                // clear serach
                clearSearch();
            }
            // shows sub options and adjusts right CSS attribute correctly
            if (subOptions) {
                subOptions.classList.add('show');
                subOptions.parentElement.style.right = '-' + subOptions.offsetWidth + 'px';
            }
        }, moveTimerDelay);
    };
    var onCloseHandler = function () {
        var selectedSubOptions = document.querySelectorAll('ul.sub-options.show');
        if (selectedSubOptions) {
            selectedSubOptions.forEach(function (sOpts) {
                sOpts.classList.remove('show');
            });
        }
        onClose && onClose();
    };
    var isSelected = function (option) {
        var exists = filters.filter(function (o) { return (o.value === option.value && o.label === option.label); }).length > 0;
        return exists;
    };
    var searchBox = function (option) {
        return (React.createElement("li", { className: "search-box" },
            React.createElement("input", { type: "text", onKeyUp: onSearch, id: "filters_search", defaultValue: searchValue, placeholder: "Search " + option.label })));
    };
    var renderSubOptions = function (option) {
        var _a;
        var hasOptions = option.hasOwnProperty('options');
        if (!hasOptions) {
            return;
        }
        var showSearch = option.enableSearch;
        var className = option.className || '';
        var filteredOptions = option.options || [];
        if (searchValue) {
            filteredOptions = (_a = option.options) === null || _a === void 0 ? void 0 : _a.filter(function (o) {
                return o.label.toLowerCase().indexOf(searchValue.toLowerCase()) === 0;
            });
        }
        return (React.createElement("div", { className: "abs-layer" },
            React.createElement("ul", { className: "sub-options " + (showSearch ? 'searchable' : ''), onMouseMove: function (e) { return mouseMoveHanlder(e, parseInt(option.level, 10) + 1); } },
                showSearch && searchBox(option), filteredOptions === null || filteredOptions === void 0 ? void 0 :
                filteredOptions.map(function (o, subIndex) {
                    var hasSubOptions = o.hasOwnProperty('options');
                    return (React.createElement("li", { key: "option-" + option.key + "-" + subIndex, className: hasSubOptions ? "has-options level-" + (o.level || '2') + " " + className : className, onClick: function (e) { return addFilter(e, __assign(__assign({}, o), { key: o.key || option.key, parent: option })); } },
                        o.checkbox && React.createElement(CustomCheckbox, { checked: isSelected(o) }),
                        o.label,
                        renderSubOptions(o)));
                }))));
    };
    return (React.createElement("div", { className: "filters" },
        React.createElement(Dropdown, { title: label, align: align, onClose: onCloseHandler, forceClose: forceClose, setForceClose: setForceClose, buttonClassName: options.length ? buttonClassName : disabledButtonClassName, className: className },
            React.createElement("ul", { className: "filter-list", onMouseMove: function (e) { return mouseMoveHanlder(e, 1); } }, options && options.map(function (option, i) {
                var hasOptions = option.hasOwnProperty('options');
                var className = option.className || '';
                return (React.createElement("li", { key: "option-" + i, onClick: function (e) { return addFilter(e, option); }, className: hasOptions ? 'has-options level-1 ' + className : className },
                    option.label,
                    renderSubOptions(option)));
            }))),
        !!filters.length &&
            filters.map(function (f, index) { return (React.createElement("button", { title: f.label, key: "filter-button-" + index, onClick: function (e) { return removeFilter(e, f); }, className: "filter " + buttonClassName },
                React.createElement("span", { className: "text" }, f.label),
                React.createElement("span", { className: "close" }, "\u00D7"))); })));
};
